import React, { ImgHTMLAttributes } from 'react'
import crystalTransport from './HoneyStacked/crystal.png'

export const Honey: React.FC<ImgHTMLAttributes<HTMLImageElement>> = (props) => (
  <img
    src={crystalTransport}
    width={33}
    height={34}
    alt="Honey"
    style={{ display: 'block' }}
    {...props}
  />
)
